function parse() {
    const result = []

    document.querySelectorAll('#accordeon').forEach(function (item, index) {
        result.push({
            MIGX_id: (index + 1),
            name: item.querySelector('.acc-head').innerHTML,
            description: item.querySelector('.acc-body').innerHTML,
        })
    })

    console.log(JSON.stringify(result))
}

document.addEventListener("DOMContentLoaded", function () {
    Fancybox.defaults.l10n = {
        CLOSE: 'Закрыть',
        NEXT: 'Следующий',
        PREV: 'Предыдущий',
        MODAL: 'Вы можете закрыть окно нажатием ESC',
        ERROR: 'Ошибка, попробуйте повторить попытку',
        IMAGE_ERROR: 'Изображение не найдено',
        ELEMENT_NOT_FOUND: 'HTML элемент не найден',
        AJAX_NOT_FOUND: 'Ошибка загрузки AJAX: Не найдено',
        AJAX_FORBIDDEN: 'Ошибка загрузки AJAX: Запрещено',
        IFRAME_ERROR: 'Ошибка при загрузке фрейма',
        TOGGLE_ZOOM: 'Приблизить',
        TOGGLE_THUMBS: 'Миниатюры',
        TOGGLE_SLIDESHOW: 'Слайдшоу',
        TOGGLE_FULLSCREEN: 'Полноэкранный режим',
        DOWNLOAD: 'Загрузить'
    }

    Fancybox.bind('[data-fancybox]', {
        dragToClose: false,
        hideScrollbar: true,
    });

    const fixedHeader = function () {
        const header = document.querySelector('.header')
        if (window.scrollY > 300) {
            header.classList.add('fixed')
        } else {
            header.classList.remove('fixed')
        }
    }

    window.addEventListener('scroll', fixedHeader);

    fixedHeader()

    const telephonesInput = document.querySelectorAll('input[type="tel"]')

    if (telephonesInput.length > 0) {
        const telephoneMask = new Inputmask({mask: '+7 (999) 999-99-99'})

        telephonesInput.forEach(function (item) {
            telephoneMask.mask(item);
        })
    }

    const callbackFormTitles = document.querySelectorAll('[data-src="#callback"]')

    callbackFormTitles.forEach(function (element) {
        element.addEventListener('click', function () {
            document.getElementById('callback').querySelector('.title').innerHTML = element.innerHTML
        })
    })

    const menu = document.querySelectorAll('.modal-menu .with-dropdown')

    menu.forEach(function (element) {
        element.addEventListener('click', function (evt) {
            if (evt.target.getAttribute('itemprop') == 'name' || evt.target.classList.contains('dropdown') || evt.target.closest('.dropdown')) {
                return
            }
            evt.preventDefault()
            element.classList.toggle('active')
        })
    })

    /*if (Cookies.get('geolocation') != 'set') {
        document.getElementById('city-dropdown').classList.toggle('active')

        Cookies.set('geolocation', 'set')
    }

    const confirmCity = document.getElementById('confirm-city')

    if (confirmCity) {
        confirmCity.addEventListener('click', function () {
            document.getElementById('city-dropdown').classList.remove('active')
        })
    }

    const changeCity = document.getElementById('change-city')

    if (changeCity) {
        changeCity.addEventListener('click', function () {
            document.getElementById('city-dropdown').classList.remove('active')
        })
    }

    const searchCityField = document.getElementById('search-city-field')

    if (searchCityField) {
        searchCityField.addEventListener('keydown', function () {
            const documentParser = new DOMParser()

            fetch(
                searchCityField.closest('form').getAttribute('action') + '?query=' + searchCityField.value,
            ).then(function (response) {
                return response.text()
            }).then(function (response) {
                response = documentParser.parseFromString(response, 'text/html')

                document.getElementById('cities-list').innerHTML = response.getElementById('cities-list').innerHTML
            })
        })
    }*/

    const forms = document.querySelectorAll(".js-form")

    for (let index = 0; index < forms.length; index++) {
        forms[index].addEventListener("submit", function (event) {
            event.preventDefault()

            forms[index].setAttribute("style", "cursor:default;pointer-events:none;opacity:0.5;")

            const path = forms[index].getAttribute("action"),
                method = forms[index].getAttribute("method"),
                formData = new FormData(forms[index])

            formData.append('page', window.location.href)

            fetch(
                path ? path : window.location.href,
                {
                    method: method,
                    redirect: "follow",
                    body: formData,
                }
            ).then(response => {
                return response.json()
            }).then(response => {
                response.messages.forEach(function (item) {
                    alert(item)
                })

                forms[index].removeAttribute("style")
            })
        })
    }

    const footerBlockLinks = document.querySelectorAll(".links .block")

    footerBlockLinks.forEach(function (element) {
        element.querySelector(".title").addEventListener("click", function (evt) {
            evt.preventDefault()

            element.classList.toggle("active")
        })
    })
})
